import { EventEmitter, Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { PipeSizeModel } from 'src/app/Modules/informate/models';
import { InputGroup } from 'src/app/Modules/informate/models/calculationModels';
import { IdmApiService } from 'src/app/services';

export class PipeSpecpayload {
    pipeCode: string;
    lookupParams: InputGroup;
}
@Injectable({
    providedIn: 'root',
})
export class JointCalcService {
    pipeSpecList: InputGroup[] = [];
    PipeSpecFilteredList: InputGroup[] = [];
    pipeSpecpayload: PipeSpecpayload;
    isPipeCode: boolean = false;
    selectedPipeCode: string = '';
    isPipeSpecEdit: boolean = false;

    isEditPipeSpec: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(null);
    ispipeSpec: EventEmitter<boolean> = new EventEmitter<boolean>(null);
    selectedTighteningMethod: BehaviorSubject<string> = new BehaviorSubject<string>(null);
    selectedPercentageCover: BehaviorSubject<string> = new BehaviorSubject<string>(null);
    selectedLubricant: BehaviorSubject<string> = new BehaviorSubject<string>(null);
    selectedStandard: BehaviorSubject<string> = new BehaviorSubject<string>(null);
    selectedPressureClass: BehaviorSubject<string> = new BehaviorSubject<string>(null);
    selectedpipeSize: BehaviorSubject<string> = new BehaviorSubject<string>(null);
    selectedflangeType: BehaviorSubject<string> = new BehaviorSubject<string>(null);
    selectedflangeFacingType: BehaviorSubject<string> = new BehaviorSubject<string>(null);
    selectedflangeMaterial: BehaviorSubject<string> = new BehaviorSubject<string>(null);
    selectedgasket: BehaviorSubject<string> = new BehaviorSubject<string>(null);
    selectedBoltType: BehaviorSubject<string> = new BehaviorSubject<string>(null);
    selectedboltMaterial: BehaviorSubject<string> = new BehaviorSubject<string>(null);
    selectedTighteningSpecification: BehaviorSubject<string> = new BehaviorSubject<string>(null);
    selectedClampManufacturer: BehaviorSubject<string> = new BehaviorSubject<string>(null);
    selectedClampSize: BehaviorSubject<string> = new BehaviorSubject<string>(null);
    selectedclampMaterial: BehaviorSubject<string> = new BehaviorSubject<string>(null);
    selectedPipeSchedule: BehaviorSubject<string> = new BehaviorSubject<string>(null);
    selectedhubMaterial: BehaviorSubject<string> = new BehaviorSubject<string>(null);
    selectedsealRingMaterial: BehaviorSubject<string> = new BehaviorSubject<string>(null);
    selectedsealRingId: BehaviorSubject<string> = new BehaviorSubject<string>(null);
    pipeSizeList: PipeSizeModel[] = [];
    activePipeSpecVersionId: string;
    constructor(private idmApiService: IdmApiService) {}

    async FinddingPipeSpecApicall(payload): Promise<InputGroup[]> {
        const res = await this.idmApiService.findpipespecs(payload).toPromise();
        this.pipeSpecList = res.response.slice();
        this.PipeSpecFilteredList = res.response.slice();
        return this.pipeSpecList;
    }

    async managePayloadForRecourdId(key: string, FilterList, nominal?: number) {
        if (!this.PipeSpecFilteredList?.length) {
            return;
        }

        if (key == 'pipeSizeId') {
            return this.PipeSpecFilteredList;
        }

        const selectedLubricantID = this.selectedLubricant?.value;
        const selectedTighteningMethodID = this.selectedTighteningMethod?.value;
        const selectedStandardID = this.selectedStandard?.value;
        const selectedPressureClassID = this.selectedPressureClass?.value;
        const selectedFlangeTypeID = this.selectedflangeType?.value;
        const selectedFlangeFacingTypeID = this.selectedflangeFacingType?.value;
        const selectedFlangeMaterialID = this.selectedflangeMaterial?.value;
        const selectedGasketID = this.selectedgasket?.value;
        const selectedBoltTypeID = this.selectedBoltType?.value == 'Metric' ? 0 : this.selectedBoltType?.value == 'Imperial' ? 1 : null;
        const selectedBoltMaterialID = this.selectedboltMaterial?.value;
        const selectedTighteningSpecificationID = this.selectedTighteningSpecification?.value;
        const selectedPipeScheduleID = this.selectedPipeSchedule?.value;
        const selectedClampManufacturerID = this.selectedClampManufacturer?.value;
        const selectedClampMaterialID = this.selectedclampMaterial?.value;
        const selectedHubMaterialID = this.selectedhubMaterial?.value;
        const selectedPipeSizeId = this.selectedpipeSize?.value;
        const selectedNominalPipeSize = this.pipeSizeList?.find((pipeSize) => pipeSize.pipeSizeId == selectedPipeSizeId)?.nominalPipeSize;

        const filterPipeSpecs = (...predicates: Array<(item: InputGroup) => boolean>) =>
            this.PipeSpecFilteredList.filter((item) => predicates.every((predicate) => predicate(item)));

        const hasNominalMatch = (item: InputGroup) =>
            selectedNominalPipeSize >= item.minimumNominalPipeSize && selectedNominalPipeSize <= item.maximumNominalPipeSize;

        const getAliasId = (item: InputGroup) => {
            if (key === 'flangeMaterialId') {
                return item.recordId['flangeMaterialAliasId'];
            }

            if (key === 'boltMaterialId') {
                return item.recordId['boltMaterialAliasId'];
            }

            if (key === 'gasketId') {
                return item.recordId['gasketAliasId'];
            }

            return '';
        };

        if (key === 'flangeMaterialId' || key === 'boltMaterialId' || key === 'gasketId') {
            if (selectedPressureClassID) {
                const pipeSpecPredicates: Record<string, Array<(item: InputGroup) => boolean>> = {
                    flangeMaterialId: [
                        (item) => String(item.others.tighteningMethod == 1 ? 'Tension' : 'Torque') == selectedTighteningMethodID,
                        (item) => item.recordId.lubricantId == selectedLubricantID,
                        (item) => item.recordId.standardId == selectedStandardID,
                        (item) => item.recordId.pressureClassId == selectedPressureClassID,
                        (item) => item.recordId.flangeTypeId == selectedFlangeTypeID,
                        hasNominalMatch,
                        (item) => item.recordId.flangeFacingTypeId == selectedFlangeFacingTypeID,
                        ...(selectedTighteningMethodID == 'Tension'
                            ? [(item) => String(parseFloat(item?.others?.percentageCover) * 100) == this.selectedPercentageCover?.value]
                            : []),
                    ],
                    gasketId: [
                        (item) => String(item.others.tighteningMethod == 1 ? 'Tension' : 'Torque') == selectedTighteningMethodID,
                        (item) => item.recordId.lubricantId == selectedLubricantID,
                        (item) => item.recordId.standardId == selectedStandardID,
                        (item) => item.recordId.pressureClassId == selectedPressureClassID,
                        (item) => item.recordId.flangeTypeId == selectedFlangeTypeID,
                        hasNominalMatch,
                        (item) => item.recordId.flangeFacingTypeId == selectedFlangeFacingTypeID,
                        (item) => item.recordId.flangeMaterialId == selectedFlangeMaterialID,
                        ...(selectedTighteningMethodID == 'Tension'
                            ? [(item) => String(parseFloat(item?.others?.percentageCover) * 100) == this.selectedPercentageCover?.value]
                            : []),
                    ],
                    boltMaterialId: [
                        (item) => String(item.others.tighteningMethod == 1 ? 'Tension' : 'Torque') == selectedTighteningMethodID,
                        (item) => item.recordId.lubricantId == selectedLubricantID,
                        (item) => item.recordId.standardId == selectedStandardID,
                        (item) => item.recordId.pressureClassId == selectedPressureClassID,
                        (item) => item.recordId.flangeTypeId == selectedFlangeTypeID,
                        hasNominalMatch,
                        (item) => item.recordId.flangeFacingTypeId == selectedFlangeFacingTypeID,
                        (item) => item.recordId.flangeMaterialId == selectedFlangeMaterialID,
                        (item) => item.recordId.gasketId == selectedGasketID,
                        (item) => item.others.boltType == selectedBoltTypeID,
                        ...(selectedTighteningMethodID == 'Tension'
                            ? [(item) => String(parseFloat(item?.others?.percentageCover) * 100) == this.selectedPercentageCover?.value]
                            : []),
                    ],
                };

                this.pipeSpecList = filterPipeSpecs(...pipeSpecPredicates[key]);
            } else if (selectedClampManufacturerID) {
                this.pipeSpecList = filterPipeSpecs((item) => item.recordId.manufacturerId == selectedClampManufacturerID);
            } else {
                this.pipeSpecList = [];
            }

            const standardpipeSpec = this.pipeSpecList.reduce((items, item) => {
                if (item?.recordId?.[key]) {
                    items.push({
                        Id: item.recordId[key],
                        AliasId: getAliasId(item),
                    });
                }

                return items;
            }, []);

            if (!standardpipeSpec.length) {
                return [...FilterList];
            }

            const uniqueIds = new Set(standardpipeSpec.map((item) => item.Id));
            const uniqueAliases = new Set(standardpipeSpec.map((item) => item.AliasId).filter((aliasId) => aliasId));

            if (uniqueAliases.size) {
                FilterList = FilterList.filter((item) => uniqueAliases.has(item?.alias?.materialAliasId));
            }

            return FilterList.filter((item) => uniqueIds.has(item[key]));
        }
        if (key == 'lubricantId') {
            if (selectedTighteningMethodID == 'Tension') {
                this.pipeSpecList = filterPipeSpecs(
                    (item) => String(item.others.tighteningMethod == 1 ? 'Tension' : 'Torque') == selectedTighteningMethodID,
                    (item) => String(parseFloat(item?.others?.percentageCover) * 100) == this.selectedPercentageCover?.value
                );
            } else
                this.pipeSpecList = filterPipeSpecs((item) => String(item.others.tighteningMethod == 1 ? 'Tension' : 'Torque') == selectedTighteningMethodID);
        } else if (key == 'standardId') {
            if (selectedTighteningMethodID == 'Tension') {
                this.pipeSpecList = filterPipeSpecs(
                    (item) => String(item.others.tighteningMethod == 1 ? 'Tension' : 'Torque') == selectedTighteningMethodID,
                    (item) => item.recordId.lubricantId == selectedLubricantID,
                    (item) => String(parseFloat(item?.others?.percentageCover) * 100) == this.selectedPercentageCover?.value
                );
            } else {
                this.pipeSpecList = filterPipeSpecs(
                    (item) => String(item.others.tighteningMethod == 1 ? 'Tension' : 'Torque') == selectedTighteningMethodID,
                    (item) => item.recordId.lubricantId == selectedLubricantID
                );
            }
        } else if (key == 'pressureClassId') {
            if (selectedTighteningMethodID == 'Tension') {
                this.pipeSpecList = filterPipeSpecs(
                    (item) => String(item.others.tighteningMethod == 1 ? 'Tension' : 'Torque') == selectedTighteningMethodID,
                    (item) => item.recordId.lubricantId == selectedLubricantID,
                    (item) => item.recordId.standardId == selectedStandardID,
                    (item) => String(parseFloat(item?.others?.percentageCover) * 100) == this.selectedPercentageCover?.value
                );
            } else {
                this.pipeSpecList = filterPipeSpecs(
                    (item) => String(item.others.tighteningMethod == 1 ? 'Tension' : 'Torque') == selectedTighteningMethodID,
                    (item) => item.recordId.lubricantId == selectedLubricantID,
                    (item) => item.recordId.standardId == selectedStandardID
                );
            }
        } else if (key == 'flangeTypeId') {
            if (selectedTighteningMethodID == 'Tension') {
                this.pipeSpecList = filterPipeSpecs(
                    (item) => String(item.others.tighteningMethod == 1 ? 'Tension' : 'Torque') == selectedTighteningMethodID,
                    (item) => item.recordId.lubricantId == selectedLubricantID,
                    (item) => item.recordId.standardId == selectedStandardID,
                    (item) => item.recordId.pressureClassId == selectedPressureClassID,
                    hasNominalMatch,
                    (item) => String(parseFloat(item?.others?.percentageCover) * 100) == this.selectedPercentageCover?.value
                );
            } else {
                this.pipeSpecList = filterPipeSpecs(
                    (item) => String(item.others.tighteningMethod == 1 ? 'Tension' : 'Torque') == selectedTighteningMethodID,
                    (item) => item.recordId.lubricantId == selectedLubricantID,
                    (item) => item.recordId.standardId == selectedStandardID,
                    (item) => item.recordId.pressureClassId == selectedPressureClassID,
                    hasNominalMatch
                );
            }
        } else if (key == 'flangeFacingTypeId') {
            if (selectedTighteningMethodID == 'Tension') {
                this.pipeSpecList = filterPipeSpecs(
                    (item) => String(item.others.tighteningMethod == 1 ? 'Tension' : 'Torque') == selectedTighteningMethodID,
                    (item) => item.recordId.lubricantId == selectedLubricantID,
                    (item) => item.recordId.standardId == selectedStandardID,
                    (item) => item.recordId.pressureClassId == selectedPressureClassID,
                    hasNominalMatch,
                    (item) => item.recordId.flangeTypeId == selectedFlangeTypeID,
                    (item) => String(parseFloat(item?.others?.percentageCover) * 100) == this.selectedPercentageCover?.value
                );
            } else {
                this.pipeSpecList = filterPipeSpecs(
                    (item) => String(item.others.tighteningMethod == 1 ? 'Tension' : 'Torque') == selectedTighteningMethodID,
                    (item) => item.recordId.lubricantId == selectedLubricantID,
                    (item) => item.recordId.standardId == selectedStandardID,
                    (item) => item.recordId.pressureClassId == selectedPressureClassID,
                    hasNominalMatch,
                    (item) => item.recordId.flangeTypeId == selectedFlangeTypeID
                );
            }
        } else if (key == 'pipeScheduleId') {
            if (selectedClampManufacturerID) {
                this.pipeSpecList = filterPipeSpecs(
                    (item) => item.recordId.lubricantId == selectedLubricantID,
                    (item) => item.recordId.manufacturerId == selectedClampManufacturerID,
                    (item) => item.recordId.boltMaterialId == selectedBoltMaterialID,
                    (item) => item.recordId.clampMaterialId == selectedClampMaterialID,
                    hasNominalMatch
                );
            } else {
                if (selectedTighteningMethodID == 'Tension') {
                    this.pipeSpecList = filterPipeSpecs(
                        (item) => String(item.others.tighteningMethod == 1 ? 'Tension' : 'Torque') == selectedTighteningMethodID,
                        (item) => item.recordId.lubricantId == selectedLubricantID,
                        (item) => item.recordId.standardId == selectedStandardID,
                        (item) => item.recordId.pressureClassId == selectedPressureClassID,
                        (item) => item.recordId.flangeTypeId == selectedFlangeTypeID,
                        hasNominalMatch,
                        (item) => item.recordId.flangeFacingTypeId == selectedFlangeFacingTypeID,
                        (item) => item.recordId.flangeMaterialId == selectedFlangeMaterialID,
                        (item) => item.recordId.gasketId == selectedGasketID,
                        (item) => item.others.boltType == selectedBoltTypeID,
                        (item) => item.recordId.boltMaterialId == selectedBoltMaterialID,
                        (item) => item.others.tighteningSpecification == selectedTighteningSpecificationID,
                        (item) => String(parseFloat(item?.others?.percentageCover) * 100) == this.selectedPercentageCover?.value
                    );
                } else {
                    this.pipeSpecList = filterPipeSpecs(
                        (item) => String(item.others.tighteningMethod == 1 ? 'Tension' : 'Torque') == selectedTighteningMethodID,
                        (item) => item.recordId.lubricantId == selectedLubricantID,
                        (item) => item.recordId.standardId == selectedStandardID,
                        (item) => item.recordId.pressureClassId == selectedPressureClassID,
                        (item) => item.recordId.flangeTypeId == selectedFlangeTypeID,
                        hasNominalMatch,
                        (item) => item.recordId.flangeFacingTypeId == selectedFlangeFacingTypeID,
                        (item) => item.recordId.flangeMaterialId == selectedFlangeMaterialID,
                        (item) => item.recordId.gasketId == selectedGasketID,
                        (item) => item.others.boltType == selectedBoltTypeID,
                        (item) => item.recordId.boltMaterialId == selectedBoltMaterialID,
                        (item) => item.others.tighteningSpecification == selectedTighteningSpecificationID
                    );
                }
            }
        } else if (key == 'manufacturerId') {
            this.pipeSpecList = filterPipeSpecs((item) => item.recordId.lubricantId == selectedLubricantID);
        } else if (key == 'clampMaterialId') {
            this.pipeSpecList = filterPipeSpecs(
                (item) => item.recordId.lubricantId == selectedLubricantID,
                (item) => item.recordId.manufacturerId == selectedClampManufacturerID,
                (item) => item.recordId.boltMaterialId == selectedBoltMaterialID,
                hasNominalMatch
            );
        } else if (key == 'hubMaterialId') {
            this.pipeSpecList = filterPipeSpecs(
                (item) => item.recordId.lubricantId == selectedLubricantID,
                (item) => item.recordId.manufacturerId == selectedClampManufacturerID,
                (item) => item.recordId.boltMaterialId == selectedBoltMaterialID,
                (item) => item.recordId.clampMaterialId == selectedClampMaterialID,
                (item) => item.recordId.pipeScheduleId == selectedPipeScheduleID
            );
        } else if (key == 'sealRingMaterialId') {
            this.pipeSpecList = filterPipeSpecs(
                (item) => item.recordId.manufacturerId == selectedClampManufacturerID,
                (item) => item.recordId.boltMaterialId == selectedBoltMaterialID,
                (item) => item.recordId.clampMaterialId == selectedClampMaterialID,
                (item) => item.recordId.pipeScheduleId == selectedPipeScheduleID,
                (item) => item.recordId.hubMaterialId == selectedHubMaterialID
            );
        } else if (selectedPressureClassID) {
            this.pipeSpecList = filterPipeSpecs((item) => item.recordId.pressureClassId == selectedPressureClassID);
        } else if (selectedClampManufacturerID) {
            this.pipeSpecList = filterPipeSpecs((item) => item.recordId.manufacturerId == selectedClampManufacturerID);
        } else {
            this.pipeSpecList = [];
        }

        const standardpipeSpec = [...new Set(this.pipeSpecList.map((item) => item?.recordId?.[key]).filter((value) => value !== undefined && value !== null))];

        if (!standardpipeSpec.length) {
            return [...FilterList];
        }
        if (this.pipeSpecList?.length == 1) {
            this.activePipeSpecVersionId = this.pipeSpecList[0]?.pipeSpecVersionId;
        } else {
            this.activePipeSpecVersionId = '';
        }
        return FilterList.filter((item) => standardpipeSpec.includes(item[key]));
    }

    filterList(payload: InputGroup): any[] {
        const filters = [
            'lubricantId',
            'standardId',
            'pressureClassId',
            'flangeTypeId',
            'flangeFacingTypeId',
            'flangeMaterialId',
            'gasketId',
            'boltMaterialId',
            'manufacturerId',
            'clampMaterialId',
            'pipeScheduleId',
            'hubMaterialId',
            'sealRingMaterialId',
        ];

        const otherFilters = ['boltType', 'tighteningSpecification'];

        const list = this.PipeSpecFilteredList.filter((item) => {
            return (
                filters.every((key) => !payload?.recordId?.[key] || item.recordId[key] === payload.recordId[key]) &&
                otherFilters.every((key) => !payload?.others?.[key] || item.others[key] === payload.others[key]) &&
                (!payload.nominal || (payload.nominal >= item.minimumNominalPipeSize && payload.nominal <= item.maximumNominalPipeSize))
            );
        });
        console.log('filtered list', list);
        if (list?.length == 1) {
            this.activePipeSpecVersionId = list[0]?.pipeSpecVersionId;
        } else {
            this.activePipeSpecVersionId = '';
        }
        return list;
    }
}
